import { TRACK_KEYS } from '@whelk/const/src/trackSpec';
import { trackCustomEvent, TrackParams } from '@whelk/utils';

export const trackMenuOpen = (trigger: string, trackParams?: TrackParams) => {
  trackCustomEvent({
    id: 'history_item_menu_open',
    open_trigger: trigger,
    ...trackParams,
  });
};

export const trackOpClick = (op: string, trackParams?: TrackParams) => {
  trackCustomEvent({
    id: 'chat_operate_click',
    [TRACK_KEYS.OPERATE_TYPE]: op,
    ...trackParams,
  });
};
